/* @flow */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'payments/reducers/activityRecipients';
import Activity from 'entities/Activity';
import ActivityRecipient from 'entities/ActivityRecipient';
import React from 'react';
import RSVPDropdown from 'payments/components/RSVPDropdown.jsx';

type Props = {
  activity: Activity,
  onRSVPChange: () => void,
  className?: ?string,
  activityRecipient?: ?ActivityRecipient,
  loadCurrentUserActivityResponse?: (activityId: number) => *,
};

class RSVPDropdownContainer extends React.Component {
  props: Props;

  componentDidMount() {
    if (!this.props.activityRecipient && this.props.loadCurrentUserActivityResponse) {
      this.props.loadCurrentUserActivityResponse(this.props.activity.id);
    }
  }

  render() {
    return <RSVPDropdown {...this.props} />;
  }
}

function mapStateToProps(state: Object, props: Object) {
  const activity = state.activityRecipients.activities[props.activity.id] || {};
  return {
    activityRecipient: activity.currentUserRecipient,
  };
}

const mapDispatchToProps = (dispatch: Function) =>
  // $FlowIssue
  bindActionCreators({
    loadCurrentUserActivityResponse: actions.loadCurrentUserActivityResponse,
  }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RSVPDropdownContainer);



// WEBPACK FOOTER //
// ./src/payments/containers/RSVPDropdownContainer.jsx